import { uploadData } from "aws-amplify/storage";
import { useField, useFormikContext } from "formik";
import * as m from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../../../reducers/app";
import Modal from "../../../common/Modal/Modal";
import SummaryItem from "../../components/SummaryItem/SummaryItem";
import "./UploadField.scss";

export default function UploadFieldGeneric(props) {
  const {
    errorText,
    customPathS3,
    prefixFileName,
    prefixFileNameFromInternalFiledName,
    customUploadMessageUploading = "cases.request_info.fields.file.uploading",
    customUploadMessageUploaded = "cases.request_info.fields.file.uploaded",
    allowDragAndDrop,
    activeStep,
    validationSchema,
    ...rest
  } = props;
  const [field, meta, helper] = useField(props);
  const { t } = useTranslation();
  const { values, setFieldError, setFieldValue, setFieldTouched } =
    useFormikContext();
  const { summaryMode } = rest;

  const { setValue } = helper;

  const fileUpload = useRef(null);

  const [uploadStatus, setUploadStatus] = useState("init");
  const [inError, setInError] = useState({ isError: false });
  const [errorRemoteUpload, setErrorRemoteUpload] = useState(false);
  const [uploadMessage, setUploadMessage] = useState(
    t("cases.request_info.fields.file.drag")
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [valueNow, setValueNow] = useState(0);
  const dispatch = useDispatch();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  const handleSelect = () => {
    // setUploadStatus('open')
    fileUpload.current.click();
  };

  useEffect(() => {
    if (inError.isError) {
      setFieldError(
        field["name"],
        t("cases.request_info.errors.file.not_supported")
      );
      setFieldValue(field["name"], "");
    }
    if (errorRemoteUpload) {
      setFieldError(field["name"], t("case.uploadField.remote.error"));
      setFieldTouched(field["name"], true);
      setUploadStatus("remoteError");
      setFieldValue(field["name"], "");
    }
    // eslint-disable-next-line
  }, [inError, errorRemoteUpload]);

  useEffect(() => {
    setErrorMessage("");
    setUploadStatus("init");
  }, [activeStep]);

  const getExtensionFromType = (type) => {
    switch (type) {
      case "text/plain":
        return "txt";
      case "application/msword":
        return "doc";
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return "docx";
      default:
        return type.split("/")[1];
    }
  };

  useEffect(() => {
    if (selectedFile) {
      setUploadMessage(t(customUploadMessageUploading));
      setUploadStatus("upload");
      const extension = getExtensionFromType(selectedFile.type);
      const timestamp = m().unix();
      // const fileSize = selectedFile.size / 1024 / 1024;
      const prefixNamePart = prefixFileName
        ? prefixFileName
        : values[prefixFileNameFromInternalFiledName] === "ID"
        ? "CI"
        : t(values[prefixFileNameFromInternalFiledName]);
      const fileNameUpload = `${prefixNamePart}-${timestamp}.${extension}`;
      setFieldValue(field["name"], "");
      dispatch(showLoading());
      uploadData({
        key: fileNameUpload,
        data: selectedFile,
        options: {
          accessLevel: "private",
          contentType: selectedFile.type,
        },
      })
        .result.then((result) => {
          // result.key contiene la chiave del file caricato
          setValue(fileNameUpload);
          setErrorRemoteUpload(false);
          dispatch(hideLoading());
        })
        .catch((error) => {
          console.log("Upload Error:", error);
          setErrorRemoteUpload(true);
          dispatch(hideLoading());
        });
      // eslint-disable-next-line
      for (let i = 0; i <= 100; i++) {
        setTimeout(() => {
          setValueNow(i);
        }, 1000);
      }
      setTimeout(() => {
        setUploadMessage(t(customUploadMessageUploaded));
        setUploadStatus("uploaded");
        setErrorMessage("");
        setValueNow(0);
        document.querySelector(".action-buttons").style.display = "flex";
      }, 2 * 1000);
    }
  }, [selectedFile]); // eslint-disable-line react-hooks/exhaustive-deps
  const handleFile = (file) => {
    if (validateFile(file)) {
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 10) {
        setFieldError(field["name"], "");
        setFieldTouched(field["name"], false);
        setInError({ isError: true });
        setUploadMessage("");
        setUploadStatus("has-error");
        setErrorMessage(t("common.fileSizeAllowed"));
      } else {
        setSelectedFile(file);
        setInError({ isError: false });
      }
    } else {
      setFieldError(field["name"], "");
      setFieldTouched(field["name"], false);
      setInError({ isError: true });
      setUploadMessage("");
      setUploadStatus("has-error");
      setErrorMessage(t("cases.request_info.errors.file.not_supported"));
    }
  };
  const validateFile = (file) => {
    const validTypes = rest.allowedExtensions;
    if (validTypes.indexOf(file.type) === -1) {
      return false;
    }
    return true;
  };
  const onChange = (e) => {
    e.preventDefault();
    setUploadStatus("select");
    let file = e.target.files[0];
    if (file) {
      handleFile(file);
      field.onChange(e);
    }
  };
  useEffect(() => {
    if (
      meta.touched &&
      meta.error &&
      uploadStatus !== "upload" &&
      uploadStatus !== "uploaded"
    ) {
      setUploadStatus("has-error");
      setErrorMessage(meta.error);
    }
  }, [meta.touched, meta.error, uploadStatus]);
  return (
    <div>
      {!summaryMode ? (
        <div className="UploadField">
          <Form.Group>
            <div className={"upload_file_box"}>
              {rest.label && (
                <Form.Label
                  className="paragraph-small-fs9"
                  htmlFor={field.name}
                >
                  {rest.label}
                  {rest.infoUploadModalMessage && (
                    <button
                      type="button"
                      className={"form-info-button"}
                      onClick={() => setShowInfoModal(true)}
                      aria-label={t("aria.form.info.button")}
                      aria-haspopup="dialog"
                      aria-controls={field.name + "-info-modal"}
                    >
                      <i className="form-icon-info" aria-hidden="true" />
                    </button>
                  )}
                </Form.Label>
              )}
              {rest.infoUploadModalMessage && (
                <Modal
                  show={showInfoModal}
                  onClose={() => setShowInfoModal(false)}
                  description={rest.infoUploadModalMessage}
                  type={"button"}
                  linkTitle={t("common.hoCapito")}
                  onFirstClick={() => setShowInfoModal(false)}
                />
              )}
              <Fragment>
                <input
                  key={field.name}
                  type="file"
                  name={field.name}
                  onChange={onChange}
                  as="upload"
                  accept={[...rest.allowedExtensions]}
                  className={
                    meta.touched && meta.error ? "is-invalid" : "nothing"
                  }
                  ref={fileUpload}
                  style={{ display: "none" }}
                  aria-describedby={
                    meta.touched && meta.error ? field.name + "-error" : null
                  }
                  required={isRequired}
                  id={field.name}
                />

                <Button
                  id={field.name + "-button"}
                  onClick={handleSelect}
                  variant={
                    errorMessage
                      ? "secondary btn-icon btn-icon-right is-invalid"
                      : "secondary btn-icon btn-icon-right"
                  }
                >
                  {t("cases.buttons.select_file")}
                  <i
                    className="gc-icon-functional-upload"
                    aria-hidden="true"
                  ></i>
                </Button>
              </Fragment>
            </div>
            {meta.value !== "" && (
              <p className="paragraph-small-form">{meta.value}</p>
            )}
            <div>
              {errorMessage && (
                <p
                  className="form-error-text paragraph-small-form"
                  role="alert"
                  id={field.name + "-error"}
                >
                  {errorMessage}
                </p>
              )}
            </div>
          </Form.Group>
        </div>
      ) : (
        <>
          <Form.Group>
            {rest.labelSummary && (
              <span className="paragraph-small-fs9">{rest.label}</span>
            )}
            <SummaryItem value={field.value} error={meta.error} />
          </Form.Group>
        </>
      )}
    </div>
  );
}
